<template>
  <div>
    <div v-if="showActionControls" class="pa-3">
      <action-video-controls
        v-for="c in contexts"
        :class="{ masked: c.groupId !== group.id }"
        :key="c.id"
        :context="c"
        :actionData="actionData"
        @update="updateAction(c)"
        @close="closeAction(c)"
      />
    </div>

    <portal to="receivedAction">
      <action-video-content
        v-if="isContentVisible"
        :class="actionContentClass"
        :state="receivedState"
      />
    </portal>
  </div>
</template>

<script>
import GenericAction from '../GenericAction';
import ActionVideoControls from './ActionVideoControls';
import ActionVideoContent from './ActionVideoContent';

export default {
  name: 'ActionVideo',
  mixins: [GenericAction],
  components: {
    ActionVideoControls,
    ActionVideoContent,
  },
  data() {
    return {
      receivedState: {},
      watchedVideos: [],
    };
  },
  computed: {
    isContentVisible() {
      return this.showActionContent(this.receivedState);
    },
  },
  watch: {
    receivedState: {
      immediate: true,
      deep: true,
      handler() {
        this.trackReceivedVideo();
      },
    },
  },
  methods: {
    trackReceivedVideo() {
      const { action, videoUrl, friendly_name = '' } = this.receivedState;

      if (!this.isContentVisible || this.isHost || action !== 'play') return;
      if (this.watchedVideos.includes(videoUrl)) return;

      this.watchedVideos.push(videoUrl);

      this.track('received_video', {
        video: videoUrl,
        friendly_name,
      });
    },

    selected() {
      this.addContext({
        show: false,
        videoUrl: '',
        action: '',
        seconds: 0,
        playerStatus: '',
        hostId: this.roomInfo?.identity,
      });
    },

    updateAction(context) {
      this.api.trigger('stateChange', { contexts: this.contexts });
      this.updateParticipants(context);
    },

    received(data) {
      this.receivedState = data;
    },
  },
};
</script>

<style scoped>
.volume-controls {
  /*font-size: .5em;*/
  color: white;
  float: right;
  min-height: 40px;
  vertical-align: middle;
  display: inline-block;
}

.masked {
  opacity: 0;
  height: 1px;
  width: 1px;
}

video,
iframe {
  background: #004e75;
}
</style>
